<div class="content-block dx-card responsive-paddings">
  <dx-form id="form"
           labelLocation="left"
           labelMode="floating"
           [formData]="investmentRequest"
           [colCount]="2"
           (onFieldDataChanged)="onFieldDataChanged($event)"
           [readOnly]="isFormReadOnly"
           [showValidationSummary]="true"
           validationGroup="registrationData">
    <dxi-form-item dataField="investmentRequestTypeId"
              editorType="dxLookup"
              [isRequired]="true"
              [editorOptions]="investmentRequestTypeEditorOptions"
              [colSpan]="2">
      <dxo-form-label text="Causale"></dxo-form-label>
      <dxi-form-validation-rule type="required"></dxi-form-validation-rule>

    </dxi-form-item>
    @if ((isAreaManager || isAdministrator) && currentInvestmentRequestKind !== null) {
    <dxi-form-item dataField="investmentRequestStateId"
              editorType="dxLookup"
              [editorOptions]="investmentRequestStatesEditorOptions"
              [colSpan]="2">
      <dxo-form-label text="Stato"> </dxo-form-label>
      <dxi-form-validation-rule type="required"
                           message="Lo stato è richiesto">
      </dxi-form-validation-rule>
    </dxi-form-item>
    }
    @if (currentInvestmentRequestKind !== null)
    {
    @if (
    currentInvestmentRequestKind !== allInvestmentRequestKinds.BuoniCarburante &&
    currentInvestmentRequestKind !== allInvestmentRequestKinds.BuoniSpesa &&
    currentInvestmentRequestKind !== allInvestmentRequestKinds.GrantMedici &&
    currentInvestmentRequestKind !== allInvestmentRequestKinds.MaterialeElettronico &&
    currentInvestmentRequestKind !== allInvestmentRequestKinds.MaterialeSanitario &&
    currentInvestmentRequestKind !== allInvestmentRequestKinds.VisiteAziendali &&
    currentInvestmentRequestKind !== allInvestmentRequestKinds.Viaggi
    )
    {
    <dxi-form-item dataField="dataInvestimento"
              editorType="dxDateBox"
              [editorOptions]="dataEditorOptions"
              [isRequired]="true"
              [colSpan]="2">
      @if (
      currentInvestmentRequestKind === allInvestmentRequestKinds.IscrizioneCongressi ||
      currentInvestmentRequestKind === allInvestmentRequestKinds.SponsorizzazioneCongressi  )
      {
      <dxo-form-label text="Data Inizio Congresso"> </dxo-form-label>
      }
      @else if(currentInvestmentRequestKind === allInvestmentRequestKinds.Cene)
      {
      <dxo-form-label text="Data Cena"></dxo-form-label>
      }
      @else
      {
      <dxo-form-label text="Data Investimento"> </dxo-form-label>
      }
      <dxi-form-validation-rule type="required"
                           message="La data investimento è richiesta">
      </dxi-form-validation-rule>
      <dxi-form-validation-rule type="range"
                           [min]="minDate"
                           [max]="maxDate"
                           message="La data deve essere compresa tra il mese scorso e l'anno prossimo">
      </dxi-form-validation-rule>
    </dxi-form-item>
    }
    <dxi-form-item dataField="informatoreId"
              editorType="dxLookup"
              [visible]="isAreaManager"
              [editorOptions]="informatoreEditorOptions"
              [colSpan]="2">
      <dxo-form-label text="Informatore"> </dxo-form-label>
      @if (isAreaManager) {
      <dxi-form-validation-rule type="required"
                           message="L'informatore è richiesto">
      </dxi-form-validation-rule>
      }
    </dxi-form-item>
    <dxi-form-item dataField="note"
              editorType="dxTextArea"
              [editorOptions]="notesEditorOptions"
              [colSpan]="2">
      <dxo-form-label text="Note"></dxo-form-label>
    </dxi-form-item>
    <dxi-form-item dataField="investmentBudgetTypeId"
              editorType="dxLookup"
              [editorOptions]="investmentBudgetTypeEditorOptions"
              [colSpan]="2">
      <dxo-form-label text="Tipo Budget"></dxo-form-label>
    </dxi-form-item>
    <dxi-form-item dataField="importo"
              editorType="dxNumberBox"
              [editorOptions]="importoEditorOptions"
              [isRequired]="currentInvestmentRequestKind !==  allInvestmentRequestKinds.MaterialeElettronico && currentInvestmentRequestKind !== allInvestmentRequestKinds.MaterialeSanitario  && currentInvestmentRequestKind !== allInvestmentRequestKinds.VisiteAziendali && currentInvestmentRequestKind !== allInvestmentRequestKinds.IscrizioneCongressi && currentInvestmentRequestKind !== allInvestmentRequestKinds.Viaggi"
              [colSpan]="2">

      @if(currentInvestmentRequestKind === allInvestmentRequestKinds.SponsorizzazioneCongressi)
      {
      <dxo-form-label text="Importo Sponsorizzazione"></dxo-form-label>
      }
      @else if(currentInvestmentRequestKind === allInvestmentRequestKinds.Cene)
      {
      <dxo-form-label text="Importo Cena"></dxo-form-label>
      }
      @else
      {
      <dxo-form-label text="Importo"></dxo-form-label>
      }

      @if (
      currentInvestmentRequestKind !== allInvestmentRequestKinds.MaterialeElettronico &&
      currentInvestmentRequestKind !== allInvestmentRequestKinds.MaterialeSanitario &&
      currentInvestmentRequestKind !== allInvestmentRequestKinds.VisiteAziendali &&
      currentInvestmentRequestKind !== allInvestmentRequestKinds.IscrizioneCongressi &&
      currentInvestmentRequestKind !== allInvestmentRequestKinds.Viaggi )
      {
      <dxi-form-validation-rule type="range"
                           [min]="minImporto"
                           [max]="maxImporto"
                           message="L'importo deve essere maggiore di 0">
      </dxi-form-validation-rule>
      }
      @if (currentInvestmentRequestKind === allInvestmentRequestKinds.BuoniCarburante)
      {
      <dxi-form-validation-rule type="custom"
                           [validationCallback]="validateBuonoCarburante"
                           message="L'importo deve essere un multiplo di 50 Euro'">
      </dxi-form-validation-rule>
      }
    </dxi-form-item>
    }
    @if(currentInvestmentRequestKind === allInvestmentRequestKinds.Cene) {
    <dxi-form-item itemType="group"
              caption="Cena"
              [colSpan]="2">
      <dxi-form-item dataField="restaurantName"
                editorType="dxTextBox"
                [isRequired]="true"
                [colSpan]="2">
        <dxo-form-label text="Nome Ristorante"></dxo-form-label>

      </dxi-form-item>
      <dxi-form-item dataField="restaurantPlace"
                editorType="dxTextBox"
                [isRequired]="true"
                [colSpan]="2">
        <dxo-form-label text="Località Ristorante"></dxo-form-label>
      </dxi-form-item>
      <dxi-form-item dataField="restaurantMail"
                editorType="dxTextBox"
                [editorOptions]="restaurantMailEditorOption"
                [isRequired]="true"
                [colSpan]="2">
        <dxo-form-label text="E-Mail Ristorante"></dxo-form-label>
        <dxi-form-validation-rule type="email"></dxi-form-validation-rule>
      </dxi-form-item>
      <dxi-form-item dataField="restaurantPhone"
                editorType="dxTextBox"
                [editorOptions]="restaurantPhoneEditorOption"
                [isRequired]="true"
                [colSpan]="2">
        <dxo-form-label text="Telefono Ristorante"></dxo-form-label>
      </dxi-form-item>
      <dxi-form-item dataField="restaurantAttendees"
                editorType="dxNumberBox"
                [editorOptions]="positiveIntegerEditorOptions"
                [isRequired]="true"
                [colSpan]="2">
        <dxo-form-label text="Numero di partecipanti"></dxo-form-label>
      </dxi-form-item>
    </dxi-form-item>
    }
    @if(currentInvestmentRequestKind === allInvestmentRequestKinds.MaterialeElettronico) {
    <dxi-form-item itemType="group"
              caption="Materiale Elettronico"
              [colSpan]="2">
      <dxi-form-item dataField="materialDescription"
                editorType="dxTextArea"
                [editorOptions]="notesEditorOptions"
                [isRequired]="true"
                [colSpan]="2">
        <dxo-form-label text="Descrizione Materiale"></dxo-form-label>
      </dxi-form-item>
    </dxi-form-item>
    }
    @if(currentInvestmentRequestKind === allInvestmentRequestKinds.IscrizioneCongressi) {
    <dxi-form-item itemType="group"
              caption="Iscrizione Congressi"
              [colSpan]="2">
      <dxi-form-item dataField="conventionRegistrationName"
                editorType="dxTextBox"
                [isRequired]="true"
                [colSpan]="2">
        <dxo-form-label text="Nome del Congresso"></dxo-form-label>
      </dxi-form-item>
      <dxi-form-item dataField="conventionRegistrationDistrictId"
                editorType="dxLookup"
                [editorOptions]="conventionRegistrationDistrictEditorOptions"
                [isRequired]="true"
                [colSpan]="2">
        <dxo-form-label text="Luogo del congresso"></dxo-form-label>
      </dxi-form-item>
    </dxi-form-item>
    }
    @if(currentInvestmentRequestKind === allInvestmentRequestKinds.SponsorizzazioneCongressi) {
    <dxi-form-item itemType="group"
              caption="Sponsorizzazione Congressi"
              [colSpan]="2">
      <dxi-form-item dataField="conventionRegistrationName"
                editorType="dxTextBox"
                [isRequired]="true"
                [colSpan]="2">
        <dxo-form-label text="Nome del Congresso"></dxo-form-label>
      </dxi-form-item>
      <dxi-form-item dataField="conventionRegistrationDistrictId"
                editorType="dxLookup"
                [editorOptions]="conventionRegistrationDistrictEditorOptions"
                [isRequired]="true"
                [colSpan]="2">
        <dxo-form-label text="Luogo del congresso"></dxo-form-label>
      </dxi-form-item>
      <dxi-form-item dataField="sponsorshipExhibition"
                editorType="dxCheckBox">
        <dxo-form-label text="Affitto spazio espositivo"></dxo-form-label>
      </dxi-form-item>
    </dxi-form-item>
    }
    @if(currentInvestmentRequestKind === allInvestmentRequestKinds.Viaggi) {
    <dxi-form-item itemType="group"
              caption="Viaggi"
              [colSpan]="2">
      <dxi-form-item dataField="travelDestination"
                editorType="dxTextBox"
                [isRequired]="true"
                [colSpan]="2">
        <dxo-form-label text="Destinazione"></dxo-form-label>
      </dxi-form-item>
      <dxi-form-item dataField="travelCheckIn"
                editorType="dxDateBox"
                [editorOptions]="dataEditorOptions"
                [isRequired]="true"
                [colSpan]="2">
        <dxo-form-label text="Check-In"></dxo-form-label>
      </dxi-form-item>
      <dxi-form-item dataField="travelCheckOut"
                editorType="dxDateBox"
                [editorOptions]="dataEditorOptions"
                [colSpan]="2">
        <dxo-form-label text="Check-Out"></dxo-form-label>
        <dxi-form-validation-rule type="required"></dxi-form-validation-rule>
        <dxi-form-validation-rule type="compare"
                             [comparisonTarget]="travelCheckInComparison"
                             comparisonType=">="
                             message="La data deve essere uguale o successiva a quella di Check IN">

        </dxi-form-validation-rule>
      </dxi-form-item>
      <dxi-form-item dataField="travelTreatment"
                editorType="dxSelectBox"
                [editorOptions]="travelTreatmentEditorOptions"
                [isRequired]="currenttravelCheckIn !== currenttravelCheckOut"
                [colSpan]="2">
        <dxo-form-label text="Trattamento"></dxo-form-label>
      </dxi-form-item>
      <dxi-form-item dataField="travelRoom"
                editorType="dxSelectBox"
                [editorOptions]="travelRoomEditorOptions"
                [isRequired]="currenttravelCheckIn !== currenttravelCheckOut"
                [colSpan]="2">
        <dxo-form-label text="Tipologia camera"></dxo-form-label>
      </dxi-form-item>
    </dxi-form-item>
    }
    @if(currentInvestmentRequestKind === allInvestmentRequestKinds.VisiteAziendali) {
    <dxi-form-item itemType="group"
              caption="Visita Aziendale"
              [colSpan]="2">
      <dxi-form-item dataField="companyVisitDate"
                editorType="dxDateBox"
                [editorOptions]="dataEditorOptions"
                [isRequired]="true"
                [colSpan]="2">
        <dxo-form-label text="Data Visita reparto produttivo"> </dxo-form-label>
        <dxi-form-validation-rule type="required"></dxi-form-validation-rule>
        <dxi-form-validation-rule type="range"
                             [min]="minDate"
                             [max]="maxDate"
                             message="La data deve essere compresa tra il mese scorso e l'anno prossimo">
        </dxi-form-validation-rule>
      </dxi-form-item>
      <dxi-form-item dataField="companyVisitCheckIn"
                editorType="dxDateBox"
                [editorOptions]="dataEditorOptions"
                [isRequired]="true"
                [colSpan]="2">
        <dxo-form-label text="Check IN"> </dxo-form-label>
        <dxi-form-validation-rule type="required"></dxi-form-validation-rule>
        <dxi-form-validation-rule type="range"
                             [min]="minDate"
                             [max]="maxDate"
                             message="La data deve essere compresa tra il mese scorso e l'anno prossimo">
        </dxi-form-validation-rule>
      </dxi-form-item>
      <dxi-form-item dataField="companyVisitCheckOut"
                editorType="dxDateBox"
                [editorOptions]="dataEditorOptions"
                [isRequired]="true"
                [colSpan]="2">
        <dxo-form-label text="Check OUT"> </dxo-form-label>
        <dxi-form-validation-rule type="required"></dxi-form-validation-rule>
        <dxi-form-validation-rule type="range"
                             [min]="minDate"
                             [max]="maxDate"
                             message="La data deve essere compresa tra il mese scorso e l'anno prossimo">
        </dxi-form-validation-rule>
        <dxi-form-validation-rule type="compare"
                             [comparisonTarget]="companyVisitCheckInComparison"
                             comparisonType=">="
                             message="La data deve essere uguale o successiva a quella di Check IN">

        </dxi-form-validation-rule>
      </dxi-form-item>
    </dxi-form-item>
    }
    @if(currentInvestmentRequestKind === allInvestmentRequestKinds.MaterialeSanitario) {
    <dxi-form-item itemType="group"
              caption="Materiale Sanitario"
              [colSpan]="2">
      <dxi-form-item dataField="materialDescription"
                editorType="dxTextArea"
                [editorOptions]="notesEditorOptions"
                [isRequired]="true"
                [colSpan]="2">
        <dxo-form-label text="Descrizione Materiale"></dxo-form-label>
      </dxi-form-item>
      <dxi-form-item dataField="sanitaryMaterialMedicalObject"
                editorType="dxCheckBox">
        <dxo-form-label text="Oggetto Medico"></dxo-form-label>
      </dxi-form-item>
      <dxi-form-item dataField="sanitaryMaterialPrescriptionPad"
                editorType="dxCheckBox">
        <dxo-form-label text="Ricettari Medici"></dxo-form-label>
      </dxi-form-item>
      <dxi-form-item dataField="sanitaryMaterialPriceList"
                editorType="dxCheckBox">
        <dxo-form-label text="Listino Personalizzato">
        </dxo-form-label>
      </dxi-form-item>
    </dxi-form-item>
    }
    @if(currentInvestmentRequestKind === allInvestmentRequestKinds.BuoniSpesa) {
    <dxi-form-item itemType="group"
              caption="Buoni Spesa"
              [colSpan]="2">
      <dxi-form-item dataField="investmentRequestVoucherTypeId"
                editorType="dxLookup"
                [isRequired]="true"
                [editorOptions]="investmentRequestVoucherTypeEditorOptions"
                [colSpan]="2">
        <dxo-form-label text="Tipo di Buoni"></dxo-form-label>
        <dxi-form-validation-rule type="required"></dxi-form-validation-rule>

      </dxi-form-item>
      <dxi-form-item dataField="voucherCount"
                editorType="dxNumberBox"
                [editorOptions]="positiveIntegerEditorOptions"
                [isRequired]="true"
                [colSpan]="2">
        <dxo-form-label text="Numero di buoni"></dxo-form-label>
      </dxi-form-item>
    </dxi-form-item>
    }

    @if(!isFormReadOnly && currentInvestmentRequestKind !== null) {

    <dxi-form-item itemType="button"
              [colSpan]="1"
              horizontalAlignment="center"
              [buttonOptions]="aggiungiMedicoButtonOptions">
    </dxi-form-item>

    <dxi-form-item itemType="button"
              [colSpan]="1"
              horizontalAlignment="center"
              [buttonOptions]="submitButtonOptions">
    </dxi-form-item>
    }
  </dx-form>
</div>
@if(currentInvestmentRequestKind !== null) {
<div class="content-block dx-card responsive-paddings">

  <dx-data-grid id="gridContainer"
                [dataSource]="investmentRequest.investmentRequestDoctors"
                keyExpr="investmentRequestDoctorId"
                [showBorders]="false"
                [rowAlternationEnabled]="true"
                noDataText="Nessun medico inserito"
                [hoverStateEnabled]="true">
    <dxo-data-grid-editing [allowDeleting]="!isFormReadOnly">
    </dxo-data-grid-editing>
    <dxi-data-grid-column dataField="surname"
                caption="Cognome">
    </dxi-data-grid-column>
    <dxi-data-grid-column dataField="name"
                caption="Nome">
    </dxi-data-grid-column>
    <dxi-data-grid-column type="buttons">
      <dxi-data-grid-button icon="edit"
                  hint="Modifica"
                  [onClick]="onEditButtonClick">
      </dxi-data-grid-button>
      <dxi-data-grid-button name="delete"></dxi-data-grid-button>
    </dxi-data-grid-column>
  </dx-data-grid>
</div>
}
